export default "__VITE_ASSET__r74_0oGs__"